/**
 * Dashboard
 */
$(document).on("ready", function () {
  if ($("#dashBoxes").length) {
    $(".block .updateStatus").on("change", function () {
      var $div = $(this).closest("div");
      var $label = $(this).closest("label").find(".dashboard-checkbox-label");
      var activity = $label.attr("data-activity");

      $label.text(
        $(this).is(":checked")
          ? "Remove completed status for " + activity
          : "Mark " + activity + " as completed"
      );
      if ($(this).is(":checked")) {
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear();
        $div.find("b").html("Completed on<br/>" + month + "/" + day + "/" + year);
      } else {
        $div.find("b").html("Check the box<br/>when completed");
      }
    });
  }
});
